// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nav_box":"nav_box-3NPkJPMR","nav":"nav-35BRkKOI","nav_piaohong":"nav_piaohong-3KrmlDMS"};